import {
  Icons, Tooltip, Menu, Dropdown, message,
} from 'taxaroo-ui';
import { TaskEntity, TaskType } from '~src/graphql';
import { useUpsertJobTrackingByTaxYearInterviewIdMutation } from '~src/graphql/mutations/jobTracking';

const {
  Circle,
  CheckCircleOutlined,
  ExclamationCircleOutlined,
  ClockCircleOutlined,
  LoadingOutlined,
} = Icons;

function Documents(props: any) {
  const { record } = props || {};
  const { filesCompletedAt, tasks, taxYearInterviewId } = record || {};
  const documentTasks = (tasks ?? []).filter((task: TaskEntity) => task.taskType === TaskType?.Documents
    || task.taskType === TaskType?.RequestDocuments);
  const inCompleteDocumentTasks = documentTasks.filter((task: TaskEntity) => !task.completedAt);

  // graphql
  const [upsertJobTracking, { loading: loadingUpsertJobTracking }] = useUpsertJobTrackingByTaxYearInterviewIdMutation({
    onError: (error) => {
      message.error(error.message);
    },
  });

  const markComplete = async () => {
    upsertJobTracking({
      variables: {
        createJobTrackingInput: {
          taxYearInterviewId,
          filesCompletedAt: new Date(),
        },
      },
      onCompleted: () => {
        message.success('Marked as complete');
      },
    });
  };

  const markNotComplete = async () => {
    upsertJobTracking({
      variables: {
        createJobTrackingInput: {
          taxYearInterviewId,
          filesCompletedAt: null,
        },
      },
      onCompleted: () => {
        message.success('Marked as not complete');
      },
    });
  };

  if (loadingUpsertJobTracking) {
    return <LoadingOutlined className="status-icon" />;
  }
  const markReadMenu = (
    <Menu>
      <Menu.Item key="mark-read" onClick={markNotComplete}>
        Mark as not complete
      </Menu.Item>
    </Menu>
  );
  const markUnreadMenu = (
    <Menu>
      <Menu.Item key="mark-unread" onClick={markComplete}>
        Mark as complete
      </Menu.Item>
    </Menu>
  );

  if (filesCompletedAt) {
    return (
      <Dropdown overlay={markReadMenu} trigger={['click']}>
        <Tooltip title="Completed!">
          <CheckCircleOutlined className="status-icon" style={{ color: 'green' }} />
        </Tooltip>
      </Dropdown>
    );
  }
  if (documentTasks?.length > 0 && inCompleteDocumentTasks?.length === 0) {
    return (
      <Dropdown overlay={markUnreadMenu} trigger={['click']}>
        <Tooltip title="Client Updated Info">
          <ExclamationCircleOutlined className="status-icon" style={{ color: 'orange' }} />
        </Tooltip>
      </Dropdown>
    );
  }
  if (documentTasks?.length > 0 && inCompleteDocumentTasks?.length > 0) {
    return (
      <Dropdown overlay={markUnreadMenu} trigger={['click']}>
        <Tooltip title="Waiting for client response">
          <ClockCircleOutlined className="status-icon" style={{ color: 'orange' }} />
        </Tooltip>
      </Dropdown>
    );
  }
  return (
    <Dropdown overlay={markUnreadMenu} trigger={['click']}>
      <Tooltip title="Documents not found">
        <span role="img" tabIndex={-1} className="anticon status-icon ant-dropdown-trigger">
          <Circle width="1em" height="1em" className="status-icon" style={{ color: 'gray' }} />
        </span>
      </Tooltip>
    </Dropdown>
  );
}

export default Documents;
